import {
  BlueBirdTheme, Filter, Typography,
} from "@kitbird/core";
import { HeaderText } from "../../../components/FloatHeader/FloatHeader.style";
import {
  CardContent,
  PageCard,
  PageWrapper,
} from "../../../components/Content/Content.style";
import logo from "../../../assets/icons/logogram_bb.png";
import ReportReceiptSubmissionTable from "./components/ReportReceiptSubmissionTable";
import FilterSection from "./components/FilterSection";
import useReportReceiptSubmission from "./useReportReceiptSubmission";
import PageLoading from "../../../components/Loading/PageLoading";
import ModalReceiptDetail from "./components/ModalReceiptDetail";

const { gray } = BlueBirdTheme.colors;

const ReportReceiptSubmission = () => {
  const useCustomHook = useReportReceiptSubmission();
  const {
    isLoading,
    modalConfig,
  } = useCustomHook;

  return (<>
    <PageWrapper>
      <HeaderText>
        <Typography level={3} color={gray.title} fontWeight="medium">
          Laporan pengajuan bon
        </Typography>
      </HeaderText>
      <PageCard>
        <CardContent>
          <div style={{ display: "flex", gap: 9, justifyContent: "space-between" }}>
            <div style={{ display: "flex", gap: 9, fontWeight: 500 }}>
              <img src={logo} width={32} height={26} />
              <Typography level={4} fontWeight="medium" color={gray.subtitle}>Daftar laporan pengajuan bon</Typography>
            </div>
          </div>
          <FilterSection
            useCustomHook={useCustomHook}
          />
          <ReportReceiptSubmissionTable
            useCustomHook={useCustomHook} />
        </CardContent>
      </PageCard>
    </PageWrapper>
    {isLoading && (
      <PageLoading
        description={modalConfig?.type === "REJECT" ? "Memproses tolak pengajuan.." : "Memproses transfer dana.."}
      />
    )}
    <ModalReceiptDetail useCustomHook={useCustomHook} />
  </>);
};

export default ReportReceiptSubmission;
